import React, { useState } from 'react';
import { ColorSubProps } from '../../../puck/reusable-props/color';
import ColorPicker from '../../../puck/reusable-props/ColorPicker';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export interface ButtonCommonProps {
  textcolor: ColorSubProps;
  background: ColorSubProps;
}

interface IButtonComponentProps {
  value: ButtonCommonProps;
  onChange: (_value: ButtonCommonProps) => void;
  title?: string;
}

const ButtonCommonColor = ({
  value,
  onChange,
  title = 'Button',
}: IButtonComponentProps): React.ReactElement<ButtonCommonProps> => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  const handleBackgroundColorChange = (colorKey: string, color: string) => {
    onChange({
      ...value,
      background: {
        ...value.background,
        [colorKey]: color,
      },
    });
  };
  const handleColorChange = (colorKey: string, color: string) => {
    onChange({
      ...value,
      textcolor: {
        ...value.textcolor,
        [colorKey]: color,
      },
    });
  };

  return (
    <div>
      <div
        className="flex justify-between font-bold cursor-pointer py-2 bg-slate-100 rounded-md pagebuilder-theme"
        onClick={toggleAccordion}>
        <h3>{title}</h3>
        {!isOpen ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}
      </div>
      {isOpen && (
        <div className="flex flex-col gap-4 w-full items-center border border-gray-300 rounded p-2 pb-4">
          <ColorPicker
            value={value?.textcolor?.backgroundColor}
            onChange={color => handleColorChange('backgroundColor', color)}
            label={'Text Color'}
            tooltip={'color'}
          />
          <ColorPicker
            value={value.textcolor?.hoverColor}
            onChange={color => handleColorChange('hoverColor', color)}
            label={'Text Hover Color'}
            tooltip={'hoverColor'}
          />

          <ColorPicker
            value={value.background?.backgroundColor}
            onChange={color =>
              handleBackgroundColorChange('backgroundColor', color)
            }
            label={'Background Color'}
            tooltip={'backgroundColor'}
          />
          <ColorPicker
            value={value.background?.hoverColor}
            onChange={color => handleBackgroundColorChange('hoverColor', color)}
            label={'Hover Text Color'}
            tooltip={'hoverColor'}
          />
        </div>
      )}
    </div>
  );
};

export default ButtonCommonColor;
